import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CxFormsModule } from '@forms';

import { ThirdPartyAppsListComponent } from './third-party-apps-list.component';
import { ThirdPartyAppsService } from './third-party-apps.service';
import { ThirdPartyAppComponent } from './third-party-app.component';
import { RouterModule } from '@angular/router';
import { ThirdPartyAppRegisterComponent } from './third-party-app.register.component';


@NgModule({
    imports : [
        CommonModule,
        CxFormsModule,
        RouterModule
    ],
    declarations : [
        ThirdPartyAppsListComponent,
        ThirdPartyAppComponent,
        ThirdPartyAppRegisterComponent
    ],
    providers : [
        ThirdPartyAppsService
    ],
    exports : [
        ThirdPartyAppsListComponent,
        ThirdPartyAppComponent,
        ThirdPartyAppRegisterComponent
    ]
})
export class ThirdPartyAppsModule {}